import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import useCachedDepartmentList from '@src/adapters/hooks/department/useCachedDepartmentList';

interface Props {
  id: string;
}

function DepartmentName({ id }: Props) {
  const { getList } = useCachedDepartmentList();
  const [display, setDisplay] = useState('');
  useEffect(() => {
    getList(id).then((department) => {
      if (department && department.length === 1) {
        setDisplay(department[0].name);
      }
    });
  }, [getList, id]);
  return <Box>{display}</Box>;
}

export default DepartmentName;
